// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"sectionTitle_sectionTitle__30BP7","subtitle":"sectionTitle_subtitle__V_8N2"};